module.exports = __webpack_public_path__ + "static/media/gramophone.00717457.svg";